module.exports = __webpack_public_path__ + "img/sem_logo.1d67955d.png";